<template>
    <div class='blog-post'>
        <div class="container header">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <router-link :to="{name: 'blog'}">
                        <h1 class="title is-size-1 has-text-black has-text-weight-normal">Taskflex<span class="has-text-primary">Blog</span></h1>
                    </router-link>
                </div>
            </div>
        </div>

        <figure class="image" v-if="post">
            <img :src="post.images.large" />
        </figure>

        <div class="container post" v-if="post">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <h2 class="title post-title" v-html="post.title.rendered" />

                    <div class="columns author">
                        <div class="column author-outer">
                            <div class="author-inner has-flex-centered" v-if="!post.author_data.description">
                                <div class="media single">
                                    <div class="media-left">
                                        <figure class="image is-96x96 is-rounded">
                                            <img class="is-rounded" :src="post.author_data.avatar" alt="Placeholder image">
                                        </figure>
                                    </div>

                                    <div class="media-content">
                                        <p class="title is-6">{{post.author_data.name}}</p>
                                        <p class="subtitle is-6 has-text-primary">{{post.author_data.title}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="author-inner" v-else>
                                <div class="columns">
                                    <div class="column is-3 is-12-mobile has-text-centered">
                                        <figure class="image is-96x96 is-rounded is-centered">
                                            <img class="is-rounded" :src="post.author_data.avatar" alt="Placeholder image">
                                        </figure>

                                        <br>

                                        <p class="title is-6">{{post.author_data.name}}</p>
                                        <p class="subtitle is-6 has-text-primary">{{post.author_data.title}}</p>
                                    </div>

                                    <div class="column is-9 is-12-mobile description has-text-centered-mobile is-flex">
                                        <div class="content" v-html="post.author_data.description" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="content post-content has-text-left" v-html="post.content.rendered" />
                </div>
            </div>
        </div>


        <div class="container loading" v-else>
            <div class="columns">
                <div class="column has-background-white is-10-widescreen is-offset-1-widescreen is-12-desktop has-text-centered">
                    <div>
                        <span>Indlæser..</span> <br>
                        <b-icon icon="loading" custom-class="mdi-spin" />
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .blog-post {
        background: $background-blueish;

        .header {
            padding-left: 1.5rem;
            padding-right: 1.5rem;

            .column {
                padding-top: 20px;
            }
        }

        .image {
            margin-top: 24px;
            img {
                object-fit: cover;
                max-height: 350px; //TODO: Media query
            }
        }

        .loading {
            padding: 1.5rem 2rem;
            margin-top: 2rem;
        }

        .post {
            margin-top: 12px;

            .post-title {
                padding-top: 1rem;
                color: black;
                text-align: center;
            }



            .author {
                .author-outer {
                    padding: 1rem 2.25rem;

                    .author-inner {
                        padding: 1rem 2.25rem;
                        background-color: whitesmoke;

                        &.has-flex-centered {
                            display: flex;
                            justify-content: center;
                        }

                        .media.single {
                            .media-content {
                                align-self: center;
                            }
                        }

                        .image.is-centered {
                            margin: 0 auto;
                        }

                        .content {
                            white-space: pre-wrap;
                            align-self: center;
                        }
                    }
                }
            }

            .content.post-content {
                padding: 1rem 1.5rem;

                p {
                    line-height: 1.9;
                    margin: 15px 0;
                }
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                post: null,
            };
        },

        metaInfo() {
            if (!this.post) {
                return {};
            }

            // eslint-disable-next-line camelcase
            const { yoast_meta: { yoast_wpseo_title = null, yoast_wpseo_metadesc = null } } = this.post;

            return {
                title: yoast_wpseo_title,
                meta: [
                    { vmid: 'description', name: 'description', content: yoast_wpseo_metadesc },
                    { property: 'og:title', content: yoast_wpseo_title },
                    { property: 'og:description', content: yoast_wpseo_metadesc },
                ],
            };
        },

        computed: {
            slug() {
                return this.$route.params.slug;
            },
        },

        mounted() {
            const { slug } = this;

            this.$store
                .dispatch('blog/fetchPost', { slug })
                .then((response) => {
                    this.post = response;
                })
                // If no post is found, show error and offer redirect to some page.
                .catch(() => {
                });
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/pages/SinglePost.vue